<template>
	<span class="badge rounded-pill bg-opacity-50 bg-danger fw-light text-white mx-auto text-white-space">
		Conversación finalizada
	</span>
</template>